import api from "./axios-http";

export const loginUser = async (credentials) => {
  try {
    const response = await api.post("/api/v2/auth/login", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createVacationRequest = async (vacationData) => {
  try {
    const response = await api.post("/api/v2/vacation/request", vacationData);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getUserVacations = async (page = 0, size = 10) => {
  try {
    const response = await api.get("/api/v2/vacation/user", {
      params: { page, size },
    });
    console.log("getUserVacations response:", response.data);
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching user vacations:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    throw new Error(
      error.response?.data?.message || "Failed to fetch user vacations"
    );
  }
};

export const getVacationById = async (id) => {
  try {
    const response = await api.get(`/api/v2/vacation/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

//Bank Accounts
export const addBankAccount = async (bankAccountData) => {
  try {
    const response = await api.post(
      "/api/v2/bank-account/add",
      bankAccountData
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBankAccounts = async () => {
  try {
    const response = await api.get("/api/v2/bank-account/user");
    return response.data.data || [];
  } catch (error) {
    throw error;
  }
};

// admins
export const getBankAccountById = async (id) => {
  try {
    const response = await api.get(`/api/v2/bank-account/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateBankAccount = async (id, bankAccountData) => {
  try {
    const response = await api.put(
      `/api/v2/bank-account/${id}`,
      bankAccountData
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBankAccount = async (id) => {
  try {
    const response = await api.delete(`/api/v2/bank-account/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPayroll = async (page = 0, size = 10) => {
  try {
    const response = await api.get("/api/v2/payroll/user", {
      params: { page, size },
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCurrentUserProfile = async () => {
  try {
    const response = await api.get("/api/v2/user/profile/current");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.put("/api/v2/user/profile", profileData);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getVacationDays = async () => {
  try {
    const response = await api.get("/api/v2/vacation/days");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updatePassword = async (
  oldPassword,
  newPassword,
  confirmPassword
) => {
  try {
    const response = await api.put("/api/v2/user/profile/change-password", {
      oldPassword,
      newPassword,
      confirmPassword,
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// Request password reset (sends OTP to email)
export const requestPasswordReset = async (email) => {
  try {
    const response = await api.post(`/api/auth/forgot-Password/${email}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (
  email,
  otp,
  newPassword,
  confirmPassword
) => {
  try {
    const response = await api.put(`/api/auth/reset-password/${email}/${otp}`, {
      newPassword,
      confirmPassword,
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getOTPs = async (email, page = 0, size = 10) => {
  try {
    const response = await api.get(`/api/v2/otp/${email}`, {
      params: { page, size },
    });
    return response.data.data || [];
  } catch (error) {
    throw error;
  }
};

// Admin's

export const registerUser = async (userData) => {
  try {
    const dataWithDefaultPassword = {
      ...userData,
      password: "Pass",
    };
    const response = await api.post(
      "/api/v2/management/users/register",
      dataWithDefaultPassword
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUsers = async (page = 0, size = 100) => {
  try {
    const response = await api.get("/api/v2/management/users", {
      params: { page, size },
    });
    return response.data.data || [];
  } catch (error) {
    throw error;
  }
};

export const fetchUserProfile = async (id) => {
  try {
    const response = await api.get(`/api/v2/management/users/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await api.delete(`/api/v2/management/users/${userId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchBankAccounts = async () => {
  try {
    const response = await api.get("/api/v2/bank-account");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchBankAccountsByUserId = async (userId) => {
  try {
    const response = await api.get("/api/v2/bank-account");
    const userBankAccounts = response.data.data.filter(
      (account) => account.userId === userId
    );
    return userBankAccounts;
  } catch (error) {
    throw error;
  }
};

export const processPayroll = async (payrollData) => {
  try {
    const response = await api.post("/api/v2/payroll/process", payrollData);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getPayrollRecords = async (page = 0, size = 10) => {
  try {
    const response = await api.get("/api/v2/payroll", {
      params: { page, size },
    });
    return response.data.data || [];
  } catch (error) {
    throw error;
  }
};

export const updatePayroll = async (id, payrollData) => {
  try {
    const response = await api.put(`/api/v2/payroll/${id}`, payrollData);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const deletePayroll = async (id) => {
  try {
    const response = await api.delete(`/api/v2/payroll/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getPayrollById = async (id) => {
  try {
    const response = await api.get(`/api/v2/payroll/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getVacationRequests = async (status = "", page = 0, size = 10) => {
  try {
    const params = { page, size };
    if (status && status !== "All") {
      const statusMap = {
        Pending: "PENDING",
        Approved: "APPROVED",
        Rejected: "DENIED",
      };
      params.status = statusMap[status] || status.toUpperCase();
    }
    const response = await api.get("/api/v2/vacation", { params });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching vacation requests:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      params: { status, page, size },
    });
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw new Error(
      error.response?.data?.message || "Failed to fetch vacation requests"
    );
  }
};

export const approveVacationRequest = async (id, comment) => {
  try {
    const response = await api.put(`/api/v2/vacation/approve/${id}`, null, {
      params: { comment },
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const rejectVacationRequest = async (id, comment) => {
  try {
    const response = await api.put(`/api/v2/vacation/reject/${id}`, null, {
      params: { comment },
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const deleteVacation = async (id) => {
  try {
    const response = await api.delete(`/api/v2/vacation/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addCertificate = async (certificateData) => {
  try {
    const response = await api.post(
      `/api/v2/user/profile/certificate`,
      certificateData
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const addDiploma = async (diplomaData) => {
  try {
    const response = await api.post(
      `/api/v2/user/profile/diploma`,
      diplomaData
    );
    return response.data.data;
  } catch (error) {
    console.log("Add Diploma Error:", error);
    throw error;
  }
};

export const updateCertificate = async (certificateId, certificateData) => {
  try {
    const response = await api.put(
      `api/v2/user/profile/certificate/${certificateId}`,
      certificateData
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const updateDiploma = async (diplomaId, diplomaData) => {
  try {
    const response = await api.put(
      `api/v2/user/profile/diploma/${diplomaId}`,
      diplomaData
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const deleteCertificate = async (certificateId) => {
  try {
    const response = await api.delete(
      `api/v2/user/profile/certificate/${certificateId}`
    );
    return response.data.data;
  } catch (error) {
    console.log("Delete Certificate Error:", error);
    throw error;
  }
};

export const deleteDiploma = async (diplomaId) => {
  try {
    const response = await api.delete(
      `/api/v2/user/profile/diploma/${diplomaId}`
    );
    return response.data.data;
  } catch (error) {
    console.log("Delete Diploma Error:", error);
    throw error;
  }
};

export const getDepartmentById = async (id) => {
  try {
    const response = await api.get(`/api/v2/department/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateDepartment = async (id, departmentData) => {
  try {
    const response = await api.put(`/api/v2/departments/${id}`, departmentData);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDepartment = async (id) => {
  try {
    const response = await api.delete(`/api/v2/departments/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getAllDepartments = async () => {
  try {
    const response = await api.get("/api/v2/departments");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const addDepartment = async (departmentData) => {
  try {
    const response = await api.post(`/api/v2/departments`, departmentData);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const updateUserProfileById = async (userId, profileData) => {
  try {
    const response = await api.put(
      `/api/v2/user/profile/${userId}`,
      profileData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeesByType = async (type) => {
  try {
    const response = await api.get(
      `/api/v2/management/users/employees/${type}`
    );
    return response.data.data.content;
  } catch (error) {
    throw error;
  }
};

export const getSalaryMetrics = async (employeeId) => {
  try {
    const response = await api.get(`/api/v2/salary-metrics/${employeeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendPayslip = async (employeeId) => {
  try {
    const response = await api.post(
      `/api/v2/salary-metrics/${employeeId}/send-payslip`
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateProfilePhoto = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.put('/api/v2/user/profile/profile-photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Update error:', error.response?.status, error.response?.data);
    throw error;
  }
};

export const getProfilePhoto = async () => {
  try {

    const response = await api.get('/api/v2/user/profile/profile-photo', {
      responseType: 'blob',
    });
    return response.data; 
  } catch (error) {
    console.error('Get error:', error.response?.status, error.response?.data);
    throw error;
  }
};

export const saveJiraTask = async (jiraTaskData) => {
  try {
    const response = await api.post('/api/v2/metrics/jira-tasks', jiraTaskData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendMetricsReports = async () => {
  try {
    const response = await api.post('/api/v2/metrics/send-reports', {});
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const completeJiraTask = async (taskId, completedDate) => {
  try {
    const response = await api.put(`/api/v2/metrics/jira-tasks/${taskId}/complete`, { completedDate });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserTasks = async (userId, startDate, endDate) => {
  try {
    const response = await api.get(`/api/v2/metrics/users/${userId}/tasks`, {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const sendMetricsReportsToManagers = async () => {
  try {
    const response = await api.post('/api/v2/metrics/send-reports-to-managers', {});
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeeTasksForValidation = async (employeeId, startDate, endDate) => {
  try {
    const response = await api.get(`/api/v2/task-validation/tasks?employeeId=${employeeId}&startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getValidationsByManager = async () => {
  try {
    const response = await api.get('/api/v2/task-validation/manager');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateTask = async (taskData) => {
  try {
    const response = await api.post('/api/v2/task-validation/validate', taskData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getValidationsByEmployee = async (userId) => {
  try {
    const response = await api.get(`/api/v2/task-validation/employee/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTasksByWeek = async (userId, month, week) => {
  try {
    const response = await api.get(`/api/v2/task-validation/tasks/week?userId=${userId}&month=${month}&week=${week}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTasksByMonth = async (userId, year, month) => {
  try {
    const response = await api.get(`/api/v2/task-validation/tasks/month?userId=${userId}&year=${year}&month=${month}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllTasks = async (page = 0, size = 10) => {
  try {
    const response = await api.get(`/api/v2/task-validation/tasks/all?page=${page}&size=${size}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllTasksForUser = async (userId, page = 0, size = 10) => {
  try {
    const response = await api.get(`/api/v2/metrics/users/${userId}/all-tasks?page=${page}&size=${size}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateJiraMetricsTask = async (userId, taskId, taskData) => {
  try {
    const response = await api.put(`/api/v2/metrics/users/${userId}/${taskId}/task`, taskData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalaryMetricsData = async (bankId, period) => {
  try {
    const response = await api.get(`/api/v2/salary-metrics?bankId=${bankId}&period=${period}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const sendPayslipBankId = async (bankId) => {
  try {
    const response = await api.post(`/api/v2/salary-metrics/send-payslip/${bankId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const issueBonus = async (bonusData) => {
  try {
    const response = await api.post('/api/v2/metrics/bonus-management/issue', bonusData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const clearBonusCycle = async () => {
  try {
    const response = await api.post('/api/v2/metrics/bonus-management/clear-cycle');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getManagerFeedback = async () => {
  try {
    const response = await api.get('/api/v2/metrics/manager-feedback');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBonusEligibility = async (page = 0, size = 10) => {
  try {
    const response = await api.get('/api/v2/metrics/bonus-management/eligibility', {
      params: {
        page,
        size
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getKraPin = async () => {
  try {
    const response = await api.get("/api/v2/user/profile/kra-pin");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const saveKraPin = async ({ kraPin, file }) => {
  try {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }

    const response = await api.put("/api/v2/user/profile/kra-pin", formData, {
      params: { kraPin },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getKraPinDocument = async () => {
  try {
    const response = await api.get("/api/v2/user/profile/kra-pin/document", {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};